import { render, staticRenderFns } from "./Searchbox.vue?vue&type=template&id=3ee3989b&"
import script from "./Searchbox.vue?vue&type=script&lang=ts&"
export * from "./Searchbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../voice.mave.work/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports